var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { ResponsiveLazyImage, } from '../../common/components/LazyImage';
import { display, flex, space, border, height, themeGet, fontSize, boxShadow, lineHeight, alignItems, flexDirection, justifyContent, } from 'styled-system';
import { Stoerer } from '../../common/components/Stoerer';
import { Heading, Text, SliderTitle } from '../../common/components/Text';
import { Grid, GridItem } from '../../common/components/Grid';
import { Button } from '../../common/components/Button';
import { getPageAppTrackerProps, } from '../../common/tracking/getTrackerProps';
import LegalNotesLink from '../../homepage-top-teaser/components/LegalNotesLink';
import { DisclaimerSubscription } from '../../common/event-bus/EventSubscription';
import dispatchTrackingEvent from '../../common/tracking/dispatchTrackingEvent';
var Sectiontitle = styled(SliderTitle)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
Sectiontitle.defaultProps = __assign(__assign({}, Sectiontitle.defaultProps), { px: ['sp_8', 'sp_12', null, 'sp_16'] });
var Flex = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  display: flex;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), space, alignItems, flexDirection, justifyContent);
var TeaserGrid = styled(Grid)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), flexDirection);
TeaserGrid.defaultProps = {
    px: [0, '12px', '36px', 6],
    flexDirection: ['column', 'row'],
};
var TeaserItem = styled(GridItem)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), space, height);
TeaserItem.defaultProps = {
    mb: [3, 4, null, 5],
    px: [0, '12px', null, 3],
    height: ['324px', null, '340px', '349px'],
};
var TeaserInnerContainer = styled(Flex)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  height: 100%;\n  text-decoration: none;\n"], ["\n  ", ";\n  ", ";\n  height: 100%;\n  text-decoration: none;\n"])), border, boxShadow).withComponent('a');
TeaserInnerContainer.defaultProps = {
    border: ['none', 1],
    boxShadow: ['0 2px 6px 0 rgba(192, 192, 192, 0.5)', 'none'],
};
var BaseBody = styled(Flex)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  overflow: hidden;\n  position: relative;\n  background-color: ", ";\n"], ["\n  overflow: hidden;\n  position: relative;\n  background-color: ", ";\n"])), themeGet('colors.gray.1'));
var RegularBody = styled(BaseBody)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), height);
RegularBody.defaultProps = {
    height: ['60%', null, null, '57%'],
};
var RegularFooter = styled(Flex)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", ";\n\n  height: 56%;\n"], ["\n  ", ";\n\n  height: 56%;\n"])), space);
RegularFooter.defaultProps = {
    px: 5,
};
var EnhancedBody = styled(BaseBody)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), height);
EnhancedBody.defaultProps = {
    height: ['60%', '63%', '75%', '57%'],
};
var EnhancedFooter = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), space, height, display, justifyContent, flexDirection, alignItems);
EnhancedFooter.defaultProps = {
    px: 5,
    height: ['56%', '38%', '26%', '56%'],
    display: 'flex',
    alignItems: ['center', null, null, 'flex-start'],
    justifyContent: ['center', 'start', null, 'center'],
    flexDirection: ['column', 'row', null, 'column'],
};
var TeaserImage = styled(ResponsiveLazyImage)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  height: 100%;\n"], ["\n  height: 100%;\n"])));
var TeaserTextContainer = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), display, flex, alignItems, flexDirection);
TeaserTextContainer.defaultProps = {
    display: 'flex',
    alignItems: ['center', 'flex-start', 'center', 'flex-start'],
    flexDirection: ['column', null, 'row', 'column'],
};
var TeaserButton = styled(Button)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), space, lineHeight);
TeaserButton.defaultProps = __assign(__assign({}, Button.defaultProps), { kind: 'secondary', as: 'span', mt: 'sp_12', lineHeight: 3, fontSize: 4 });
var TeaserStorer = styled(Stoerer)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  border-color: ", ";\n  ", ";\n"], ["\n  border-color: ", ";\n  ", ";\n"])), themeGet('colors.brand.normal'), fontSize);
TeaserStorer.defaultProps = {
    themeTop: [0, 3, 4, '30px'],
};
var onClickDisclaimer = function (_a) {
    var emit = _a.emit, html = _a.html;
    return function (event) {
        event.preventDefault();
        emit({ html: html, open: true });
    };
};
var LegalDisclaimer = function (_a) {
    var linkLabel = _a.linkLabel, linkLabelColor = _a.linkLabelColor, contentHtml = _a.contentHtml;
    return (React.createElement(DisclaimerSubscription, null, function (_a) {
        var emit = _a.emit;
        return (React.createElement(LegalNotesLink, { linkLabel: linkLabel, linkLabelColor: linkLabelColor, onClick: onClickDisclaimer({
                emit: emit,
                html: contentHtml,
            }) }));
    }));
};
/**
 * There should always be 3 teasers
 */
var LAST_TEASER_INDEX = 2;
var OfferTeaser = function (_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width, sectionTitle = _a.title;
    useEffect(function () {
        var offerTeaserPromotions = items.map(function (item, index) { return ({
            name: item.tracking.name,
            placement: item.tracking.placement,
            position: index,
        }); });
        dispatchTrackingEvent({
            event: 'promoView',
            eventAction: 'view',
            eventCategory: 'promotion',
            eventData: {
                promotions: offerTeaserPromotions,
            },
        });
    }, [items]);
    return (React.createElement(React.Fragment, null,
        sectionTitle && (React.createElement(TeaserGrid, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width },
            React.createElement(Sectiontitle, { "data-testid": "offer-teaser-section-title" }, sectionTitle))),
        React.createElement(TeaserGrid, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width, "data-testid": "teaser-grid" }, items.map(function (_a, index) {
            var title = _a.title, subtitle = _a.subtitle, cta = _a.cta, stoerer = _a.stoerer, teaserImage = _a.image, enhancedImage = _a.enhancedImage, legalDisclaimer = _a.legalDisclaimer, _b = _a.tracking, _c = _b === void 0 ? {} : _b, name = _c.name, placement = _c.placement;
            return index !== LAST_TEASER_INDEX ? (React.createElement(TeaserItem, { "data-testid": "offer-teaser-" + index, key: "offer-teaser-" + index, w: [1, 4 / 8, 6 / 12, 4 / 12] },
                React.createElement(TeaserInnerContainer, __assign({ flexDirection: "column" }, getPageAppTrackerProps({
                    'data-testid': 'teaser-inner-container',
                    'data-prefetch': true,
                    href: cta.href,
                }, {
                    event: 'promoClick',
                    eventData: {
                        promotions: [
                            {
                                name: name,
                                placement: placement,
                                position: index,
                            },
                        ],
                    },
                })),
                    React.createElement(RegularBody, { alignItems: "center", justifyContent: "center" },
                        stoerer && (React.createElement(TeaserStorer, { "data-testid": "stoerer", label: stoerer.label, borderColor: stoerer.borderColor })),
                        React.createElement(TeaserImage, __assign({ "data-testid": "teaser-image" }, teaserImage, { alt: teaserImage.alt || '' })),
                        legalDisclaimer && (React.createElement(LegalDisclaimer, __assign({}, legalDisclaimer)))),
                    React.createElement(RegularFooter, { flexDirection: "column", justifyContent: "center", alignItems: ['center', 'flex-start'] },
                        React.createElement(Heading, { "data-testid": "title", fontSize: ['22px', null, null, '26px'], lineHeight: ['32px', null, null, '36px'], textAlign: ['center', 'left'] }, title),
                        React.createElement(Text, { "data-testid": "subtitle", fontSize: [4, null, null, 5], lineHeight: [3, null, null, '28px'] }, subtitle),
                        React.createElement(TeaserButton, { "data-testid": "teaser-button" }, cta.label))))) : (React.createElement(TeaserItem, { "data-testid": "offer-teaser-" + index, key: "offer-teaser-" + index, w: [1, null, null, 4 / 12] },
                React.createElement(TeaserInnerContainer, __assign({ flexDirection: "column" }, getPageAppTrackerProps({
                    'data-testid': 'teaser-inner-container',
                    'data-prefetch': true,
                    href: cta.href,
                }, {
                    event: 'promoClick',
                    eventData: {
                        promotions: [
                            {
                                name: name,
                                placement: placement,
                                position: index,
                            },
                        ],
                    },
                })),
                    React.createElement(EnhancedBody, { alignItems: "center", justifyContent: "center" },
                        stoerer && (React.createElement(TeaserStorer, { "data-testid": "stoerer", label: stoerer.label, borderColor: stoerer.borderColor })),
                        React.createElement(TeaserImage, __assign({}, enhancedImage, { mobile: teaserImage.mobile, large_desktop: teaserImage.desktop, alt: enhancedImage.alt || '' })),
                        legalDisclaimer && (React.createElement(LegalDisclaimer, __assign({}, legalDisclaimer)))),
                    React.createElement(EnhancedFooter, null,
                        React.createElement(TeaserTextContainer, null,
                            React.createElement(Heading, { "data-testid": "title", fontSize: ['22px', null, null, '26px'], lineHeight: [4, null, null, '36px'], textAlign: ['center', 'left'], mr: [0, null, 4, 0] }, title),
                            React.createElement(Text, { "data-testid": "subtitle", fontSize: [4, null, null, 5], lineHeight: [3, null, null, '28px'] }, subtitle)),
                        React.createElement(TeaserButton, { mt: [3, 0, null, 3], ml: [0, '14%', null, 0], "data-testid": "teaser-button" }, cta.label)))));
        }))));
};
OfferTeaser.defaultProps = {
    __legacy_shop_reboot_max_width: true,
};
export default OfferTeaser;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;
